import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'apps/piqet-angular/src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AdministratorService {
  constructor(private http: HttpClient) {}
  apiUrl = environment.url;
  piqetLcaApiUrl = environment.piqetLcaApiUrl;
  selectedImportList$ = this.http.get<any>(`${this.apiUrl}/ImportExcel/GetImportProjectDataForAdd`);
  GetAllLoginLogs(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/LoginLog/GetAll`, payload).toPromise();
  }

  GetAllOrganizationLogs() {
    return this.http.get<any>(`${this.apiUrl}/Organization/GetCopyOrganizationLogList`);
  }

  getLoginHistory(payload: any) {
    return this.http
      .post<any>(`${this.apiUrl}/LoginLog/GetAllUserLoginLogs`, payload)
      .toPromise();
  }

  GetAdminOrganizatioList(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/Organization/GetOrganizationList`, payload);
  }

  GetAdminOrganizatioModalDataAsync(id: any) {
    return this.http
      .get<any>(`${this.apiUrl}/Organization/GetAddOrganizationFormDetail?organizationId=${id}`)
      .toPromise();
  }

  addEditAdminOrganization(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/Organization/AddUpdateOrganization`, payload);
  }

  //FOR ADMIN ORGANIZATION page only, not the whole module
  deleteAdminOrganizationsItem(id: any) {
    return this.http.delete<any>(
      `${this.apiUrl}/Organization/DeleteOrganization?organizationId=${id}`
    );
  }

  adminOrganizationInlineEdit(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/Organization/InLineEdit`, payload);
  }

  getProductContentList() {
    return this.http.get<any>(`${this.apiUrl}/ProductContent/GetProductContentList`);
  }
  saveProductContent(id: any, value: any) {
    return this.http.post<any>(
      `${this.apiUrl}/ProductContent/UpdateOrganizationProductContent?organizationId=${id}&value=${value}`,
      {}
    );
  }

  getRecycledMaterialImpact() {
    return this.http
      .get<any>(`${this.apiUrl}/RecycledMaterialImpact/GetAllRecycledMaterialImpactList`)
      .toPromise();
  }

  getMaterialListForAdmin() {
    return this.http.get<any>(`${this.apiUrl}/Material/GetAllMaterialList`).toPromise();
  }

  getIngredientsList() {
    return this.http.get<any>(`${this.apiUrl}/Ingredient/GetAllIngredientList`).toPromise();
  }

  GetAdminMaterialModalData(id: any, regionId: any) {
    return this.http.get<any>(
      `${this.apiUrl}/Material/GetMaterialDataForAddUpdate?materialId=${id}&regionId=${regionId}`
    );
  }

  GetMaterialRegions(materialId: any) {
    return this.http.get<any>(`${this.apiUrl}/Material/GetRegions?materialId=${materialId}`);
  }

  getAdminAddUpdate(materialPayload: any) {
    return this.http.post<any>(`${this.apiUrl}/Material/AddUpdateMaterial`, materialPayload);
  }

  getConversionList() {
    return this.http.get<any>(`${this.apiUrl}/Conversion/GetAllConversionList`).toPromise();
  }

  GetConversionModalData(conversionProcessId: any, regionId: any) {
    return this.http
      .get<any>(
        `${this.apiUrl}/Conversion/GetConversionForAddUpdate?conversionProcessId=${conversionProcessId}&regionId=${regionId}`
      )
      .toPromise();
  }

  GetRegions(conversionProcessId: any) {
    return this.http.get<any>(
      `${this.apiUrl}/Conversion/GetRegions?conversionProcessId=${conversionProcessId}`
    );
  }

  addUpdateConversion(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/Conversion/AddUpdateConversion`, payload);
  }

  deleteConversionData(convertingProcessId: any, regionId: any) {
    return this.http.delete<any>(
      `${this.apiUrl}/Conversion/DeleteConversion?convertingProcessId=${convertingProcessId}&&regionId=${regionId}`
    );
  }

  getAdminIngredientsModalData(ingredientId: any, regionId: any) {
    return this.http
      .get<any>(
        `${this.apiUrl}/Ingredient/GetIngredientDataForAddUpdate?ingredientId=${ingredientId}&regionId=${regionId}`
      )
      .toPromise();
  }

  addUpdateIngredient(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/Ingredient/AddUpdateIngredient`, payload);
  }

  deleteAdminMaterialData(id: any, regionId: any) {
    return this.http.delete<any>(
      `${this.apiUrl}/Material/DeleteMaterial?materialId=${id}&regionId=${regionId}`
    );
  }

  deleteAdminIngredientsData(id: any, regionId: any) {
    return this.http.delete<any>(
      `${this.apiUrl}/Ingredient/DeleteIngredient?ingredientId=${id}&regionId=${regionId}`
    );
  }

  getAdminRecycledModalData(materialId: any, regionId: any) {
    return this.http
      .get<any>(
        `${this.apiUrl}/RecycledMaterialImpact/GetRecycledMaterialImpactDataForAddUpdate?materialId=${materialId}&regionId=${regionId}`
      )
      .toPromise();
  }

  addUpdateRecycled(payload: any) {
    return this.http.post<any>(
      `${this.apiUrl}/RecycledMaterialImpact/AddUpdateRecycledMaterialImpact`,
      payload
    );
  }

  getRecycledRegions(materialId: any) {
    return this.http.get<any>(
      `${this.apiUrl}/RecycledMaterialImpact/GetRegions?materialId=${materialId}`
    );
  }

  deleteAdminRecycledData(id: any, regionId: any) {
    return this.http.delete<any>(
      `${this.apiUrl}/RecycledMaterialImpact/DeleteRecycledMaterialImpact?materialId=${id}&regionId=${regionId}`
    );
  }

  getAreaBasedConversionList() {
    return this.http
      .post<any>(`${this.apiUrl}/AreaBasedConversion/GetAllAreaBasedConversionList`, {})
      .toPromise();
  }

  deleteAreaBasedConversionData(convertingProcessId: any, regionId: any) {
    return this.http.delete<any>(
      `${this.apiUrl}/AreaBasedConversion/DeleteAreaBasedConversion?convertingProcessId=${convertingProcessId}&&regionId=${regionId}`
    );
  }

  GetAreaBasedConversionModalData(conversionProcessId: any, regionId: any) {
    return this.http
      .get<any>(
        `${this.apiUrl}/AreaBasedConversion/GetAreaBasedConversionForAddUpdate?conversionProcessId=${conversionProcessId}&regionId=${regionId}`
      )
      .toPromise();
  }

  GetRegionsForAreaBasedConversion(conversionProcessId: any) {
    return this.http.get<any>(
      `${this.apiUrl}/AreaBasedConversion/GetRegions?conversionProcessId=${conversionProcessId}`
    );
  }

  addUpdateAreaBasedConversion(payload: any) {
    return this.http.post<any>(
      `${this.apiUrl}/AreaBasedConversion/AddUpdateAreaBasedConversion`,
      payload
    );
  }

  // transport
  getTransportList() {
    return this.http.get<any>(`${this.apiUrl}/TransportMode/GetAllTransportModeList`).toPromise();
  }

  deleteTransportData(transportModeId: any, regionId: any) {
    return this.http.delete<any>(
      `${this.apiUrl}/TransportMode/DeleteTransportMode?transportModeId=${transportModeId}&&regionId=${regionId}`
    );
  }

  GetTransportModalData(transportModeId: any, regionId: any) {
    return this.http
      .get<any>(
        `${this.apiUrl}/TransportMode/GetTransportModeForAddUpdate?transportModeId=${transportModeId}&regionId=${regionId}`
      )
      .toPromise();
  }

  GetRegionsForTransport(transportmodeId: any) {
    return this.http.get<any>(
      `${this.apiUrl}/TransportMode/GetRegions?transportmodeId=${transportmodeId}`
    );
  }

  addUpdateTransport(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/TransportMode/AddUpdateTransportMode`, payload);
  }

  getProcessingCustomConversionList() {
    return this.http
      .get<any>(`${this.apiUrl}/CustomConversionIntensity/GetAllEnergyImpactList`)
      .toPromise();
  }

  deleteProcessingCustomConversionData(energyProcessId: any, regionId: any) {
    return this.http.delete<any>(
      `${this.apiUrl}/CustomConversionIntensity/DeleteEnergyImpact?energyProcessId=${energyProcessId}&regionId=${regionId}`
    );
  }

  GetProcessingCustomConversionModalData(energyProcessId: any, regionId: any) {
    return this.http
      .get<any>(
        `${this.apiUrl}/CustomConversionIntensity/GetEnergyImpactForAddUpdate?energyProcessId=${energyProcessId}&regionId=${regionId}`
      )
      .toPromise();
  }

  GetRegionsForProcessingCustomConversion(energyProcessId: any) {
    return this.http.get<any>(
      `${this.apiUrl}/CustomConversionIntensity/GetRegions?energyProcessId=${energyProcessId}`
    );
  }

  addUpdateProcessingCustomConversion(payload: any) {
    return this.http.post<any>(
      `${this.apiUrl}/CustomConversionIntensity/AddUpdateEnergyImpact`,
      payload
    );
  }

  // EnergyandAncillary

  getEnergyandAncillaryList() {
    return this.http
      .get<any>(`${this.apiUrl}/EnergyandAncillary/GetAllEnergyandAncillaryList`)
      .toPromise();
  }

  deleteEnergyandAncillaryData(energyProcessId: any, regionId: any) {
    return this.http.delete<any>(
      `${this.apiUrl}/EnergyandAncillary/DeleteEnergyandAncillary?energyProcessId=${energyProcessId}&&regionId=${regionId}`
    );
  }

  GetEnergyandAncillaryModalData(energyProcessId: any, regionId: any) {
    return this.http
      .get<any>(
        `${this.apiUrl}/EnergyandAncillary/GetEnergyandAncillaryDataForAddUpdate?energyProcessId=${energyProcessId}&regionId=${regionId}`
      )
      .toPromise();
  }

  GetRegionsForEnergyandAncillary(energyProcessId: any) {
    return this.http.get<any>(
      `${this.apiUrl}/EnergyandAncillary/GetRegions?energyProcessId=${energyProcessId}`
    );
  }

  addUpdateEnergyandAncillary(payload: any) {
    return this.http.post<any>(
      `${this.apiUrl}/EnergyandAncillary/AddUpdateEnergyandAncillary`,
      payload
    );
  }

  // storage
  getStorageList() {
    return this.http.get<any>(`${this.apiUrl}/Storage/GetAllStorageIntensityList`).toPromise();
  }

  deleteStorageData(storageId: any, regionId: any) {
    return this.http.delete<any>(
      `${this.apiUrl}/Storage/DeleteStorageIntensity?storageId=${storageId}&&regionId=${regionId}`
    );
  }

  GetStorageModalData(storageId: any, regionId: any) {
    return this.http
      .get<any>(
        `${this.apiUrl}/Storage/GetStorageIntensityForAddUpdate?storageId=${storageId}&regionId=${regionId}`
      )
      .toPromise();
  }

  GetRegionsForStorage(storageId: any) {
    return this.http.get<any>(`${this.apiUrl}/Storage/GetRegions?scenarioId=${storageId}`);
  }
  addUpdateStorage(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/Storage/AddUpdateStorageIntensity`, payload);
  }

  // waste
  getWasteList() {
    return this.http.get<any>(`${this.apiUrl}/Waste/GetAllWasteList`).toPromise();
  }

  deleteWasteData(wasteId: any, regionId: any) {
    return this.http.delete<any>(
      `${this.apiUrl}/Waste/DeleteWaste?wasteId=${wasteId}&&regionId=${regionId}`
    );
  }

  GetWasteModalData(wasteId: any, regionId: any) {
    return this.http
      .get<any>(
        `${this.apiUrl}/Waste/GetWasteDataForAddUpdate?wasteId=${wasteId}&regionId=${regionId}`
      )
      .toPromise();
  }

  GetRegionsForWaste(wasteId: any) {
    return this.http.get<any>(`${this.apiUrl}/Waste/GetRegions?wasteId=${wasteId}`);
  }

  addUpdateWaste(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/Waste/AddUpdateWaste`, payload);
  }

  // refrigareted truck
  getRefrigeratedTruckList() {
    return this.http
      .get<any>(`${this.apiUrl}/RefrigeratedTruck/GetAllRefrigeratedTruckList`)
      .toPromise();
  }

  deleteRefrigeratedTruckData(id: any) {
    return this.http.delete<any>(
      `${this.apiUrl}/RefrigeratedTruck/DeleteRefrigeratedTruck?id=${id}`
    );
  }

  GetRefrigeratedTruckModalData(id: any) {
    return this.http
      .get<any>(`${this.apiUrl}/RefrigeratedTruck/GetRefrigeratedTruckDataForAddUpdate?id=${id}`)
      .toPromise();
  }

  addUpdateRefrigeratedTruck(payload: any) {
    return this.http.post<any>(
      `${this.apiUrl}/RefrigeratedTruck/AddUpdateRefrigeratedTruck`,
      payload
    );
  }

  // processing Custom truck
  getProcessingCustomTruckList() {
    return this.http
      .get<any>(`${this.apiUrl}/ProcessingDataCustomTruck/GetAllCustomTruckList`)
      .toPromise();
  }

  deleteProcessingCustomTruckData(truckId: any) {
    return this.http.delete<any>(
      `${this.apiUrl}/ProcessingDataCustomTruck/DeleteCustomTruck?truckId=${truckId}`
    );
  }

  GetProcessingCustomTruckModalData(truckId: any) {
    return this.http
      .get<any>(
        `${this.apiUrl}/ProcessingDataCustomTruck/GetCustomTruckForAddUpdate?truckId=${truckId}`
      )
      .toPromise();
  }

  addUpdateProcessingCustomTruck(payload: any) {
    return this.http.post<any>(
      `${this.apiUrl}/ProcessingDataCustomTruck/AddUpdateCustomTruck`,
      payload
    );
  }

  // other data
  // For material-types & Recyclability & Compostability & Combustibility
  getOtherMaterialDataList(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/MaterialType/GetMaterialList`, payload);
  }

  getAllOtherMaterialDataList() {
    return this.http.get<any>(`${this.apiUrl}/MaterialType/GetAllMaterialList`);
  }
  GetOtherDataMaterialModalData(materialId: any) {
    return this.http
      .get<any>(`${this.apiUrl}/MaterialType/GetMaterialTypeForAddUpdate?materialId=${materialId}`)
      .toPromise();
  }

  GetOtherDataRecyclabilityModalData(materialId: any) {
    return this.http
      .get<any>(
        `${this.apiUrl}/Recyclability/GetRecyclabilityForAddUpdate?materialId=${materialId}`
      )
      .toPromise();
  }

  GetOtherDataCompostabilityModalData(materialId: any) {
    return this.http
      .get<any>(
        `${this.apiUrl}/Compostability/GetCompostabilityForAddUpdate?materialId=${materialId}`
      )
      .toPromise();
  }

  GetOtherDataCombustibilityModalData(materialId: any) {
    return this.http
      .get<any>(
        `${this.apiUrl}/Combustibility/GetCombustibilityForAddUpdate?materialId=${materialId}`
      )
      .toPromise();
  }

  addUpdateOtherMaterial(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/MaterialType/AddUpdateMaterialType`, payload);
  }

  addUpdateOtherRecyclability(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/Recyclability/AddUpdateRecyclability`, payload);
  }

  addUpdateOtherCombustibility(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/Combustibility/AddUpdateCombustibility`, payload);
  }

  addUpdateOtherCompostability(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/Compostability/AddUpdateCompostability`, payload);
  }

  //EOL Services
  getEOLGridData(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/EOL_AD/GetEndofLifeADList`, payload);
  }

  getEOLRegionsData(materialId: any) {
    return this.http.get<any>(`${this.apiUrl}/EOL_AD/GetRegions?materialId=${materialId}`);
  }

  getEolRCFormData(materialId: any, regionId: any, pathName: any) {
    return this.http
      .get<any>(`${this.apiUrl}${pathName}?materialId=${materialId}&regionId=${regionId}`)
      .toPromise();
  }

  async getEolRatesAddUpdate(
    materialId: any,
    regionId: any,
    endOfLifeIdentifierId: any,
    pathName: any
  ) {
    return this.http
      .get<any>(
        `${this.apiUrl}${pathName}?materialId=${materialId}&regionId=${regionId}&endOfLifeIdentifierId=${endOfLifeIdentifierId}`
      )
      .toPromise();
  }

  addUpdateEol(payload: any, pathName: any) {
    return this.http.post<any>(`${this.apiUrl}${pathName}`, payload);
  }

  addUpdateEolRates(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/EOLRates/AddUpdateEOLImpactRates`, payload);
  }

  addUpdateEolConsumer(payload: any) {
    return this.http.post<any>(
      `${this.apiUrl}/EOLConsumerRates/AddUpdateEOLImpactConsumerRates`,
      payload
    );
  }

  deleteEolData(materialId: any, regionId: any, pathName: any) {
    return this.http.delete<any>(
      `${this.apiUrl}${pathName}?materialId=${materialId}&regionId=${regionId}`
    );
  }

  getEOLRatesGridData(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/EOLRates/GetEOLRatesList`, payload);
  }

  getEOLConsumersGridData(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/EOLConsumerRates/GetEOLConsumerRatesList`, payload);
  }

  getAllEOLRatesGridData() {
    return this.http.get<any>(`${this.apiUrl}/EOL_AD/GetEndofLifeADList`);
  }

  getAllRatesGridData() {
    return this.http.get<any>(`${this.apiUrl}/EOLRates/GetAllEOLRatesList`);
  }
  getAllConsumerRatesGridData() {
    return this.http.get<any>(`${this.apiUrl}/EOLConsumerRates/GetAllEOLConsumerRatesList`);
  }

  getAllrecycledContentGirdData() {
    return this.http.get<any>(`${this.apiUrl}/RecycledContent/GetAllRecycledContentList`);
  }

  // other data CircularEconomyParameters
  getCircularEconomyParametersist(payload: any) {
    return this.http.post<any>(
      `${this.apiUrl}/CircularEconomyParameters/GetCircularEconomyParametersList`,
      payload
    );
  }

  getAllCircularEconomyParametersist() {
    return this.http.get<any>(
      `${this.apiUrl}/CircularEconomyParameters/GetAllCircularEconomyParametersList`
    );
  }

  deleteCircularEconomyParametersData(circularEconomyParameterId: any) {
    return this.http.delete<any>(
      `${this.apiUrl}/CircularEconomyParameters/DeleteCircularEconomyParameters?id=${circularEconomyParameterId}`
    );
  }

  getCircularEconomyParametersModalData(materialId: any) {
    return this.http
      .get<any>(
        `${this.apiUrl}/CircularEconomyParameters/GetCircularEconomyParametersForAddUpdate?materialId=${materialId}`
      )
      .toPromise();
  }

  addUpdateCircularEconomyParameters(payload: any) {
    return this.http.post<any>(
      `${this.apiUrl}/CircularEconomyParameters/AddUpdateCircularEconomyParameters`,
      payload
    );
  }

  // other data PalletType
  getPalletTypeList(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/PalletType/GetPalletTypeList`, payload);
  }

  getAllPalletTypeList() {
    return this.http.get<any>(`${this.apiUrl}/PalletType/GetAllPalletTypeList`);
  }

  deletePalletTypeData(id: any) {
    return this.http.delete<any>(`${this.apiUrl}/PalletType/DeletePalletType?id=${id}`);
  }

  getPalletTypeModalData(id: any) {
    return this.http
      .get<any>(`${this.apiUrl}/PalletType/GetPalletTypeForAddUpdate?id=${id}`)
      .toPromise();
  }

  addUpdatePalletType(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/PalletType/AddUpdatePalletType`, payload);
  }

  // other data Project Status
  geProjectStatusList(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/ProjectStatus/GetProjectStatusList`, payload);
  }

  getAllProjectStatusList() {
    return this.http.get<any>(`${this.apiUrl}/ProjectStatus/GetAllProjectStatusList`);
  }

  deleteProjectStatusData(id: any) {
    return this.http.delete<any>(`${this.apiUrl}/ProjectStatus/DeleteProjectStatus?id=${id}`);
  }

  getProjectStatusModalData(id: any) {
    return this.http
      .get<any>(`${this.apiUrl}/ProjectStatus/GetProjectStatusForAddUpdate?id=${id}`)
      .toPromise();
  }

  addUpdateProjectStatus(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/ProjectStatus/AddUpdateProjectStatus`, payload);
  }

  // other data Scenario Status
  getScenarioStatusList(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/ScenarioStatus/GetScenarioStatusList`, payload);
  }
  getAllScenarioStatusList() {
    return this.http.get<any>(`${this.apiUrl}/ScenarioStatus/GetAllScenarioStatusList`);
  }

  deleteScenarioStatusData(id: any) {
    return this.http.delete<any>(`${this.apiUrl}/ScenarioStatus/DeleteScenarioStatus?id=${id}`);
  }

  getScenarioStatusModalData(id: any) {
    return this.http
      .get<any>(`${this.apiUrl}/ScenarioStatus/GetScenarioStatusForAddUpdate?id=${id}`)
      .toPromise();
  }

  addUpdateScenarioStatus(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/ScenarioStatus/AddUpdateScenarioStatus`, payload);
  }

  // other data EquivalancyUnits
  getEquivalancyUnitsList(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/EquivalancyUnits/GetEquivalancyUnitsList`, payload);
  }

  getOrgEquivalancyUnitsList(payload: any) {
    return this.http.post<any>(
      `${this.apiUrl}/MyOrganizationPreferences/GetEquivalancyUnitsList`,
      payload
    );
  }

  getAllEquivalancyUnitsList() {
    return this.http.get<any>(`${this.apiUrl}/EquivalancyUnits/GetAllEquivalancyUnitsList`);
  }

  getOrgAllEquivalancyUnitsList() {
    return this.http.get<any>(
      `${this.apiUrl}/MyOrganizationPreferences/GetAllEquivalancyUnitsList`
    );
  }

  getEquivalancyUnitsModalList() {
    return this.http
      .get<any>(`${this.apiUrl}/EquivalancyUnits/GetOrganizationEquivalancyForAddUpdate`)
      .toPromise();
  }

  getOrgEquivalancyUnitsModalList() {
    return this.http
      .get<any>(`${this.apiUrl}/MyOrganizationPreferences/GetOrganizationEquivalancyForAddUpdate`)
      .toPromise();
  }

  addUpdateEquivalancyUnits(payload: any) {
    return this.http.post<any>(
      `${this.apiUrl}/EquivalancyUnits/AddUpdateOrganizationEquivalancy`,
      payload
    );
  }

  addUpdateOrgEquivalancyUnits(payload: any) {
    return this.http.post<any>(
      `${this.apiUrl}/MyOrganizationPreferences/AddUpdateOrganizationEquivalancy`,
      payload
    );
  }

  getConversionMappingList() {
    return this.http.get<any>(`${this.apiUrl}/ConversionMapping/GetAllConversionMappingList`);
  }

  getConversionFormData(materialId: any, conversionProcessId: any) {
    return this.http
      .get<any>(
        `${this.apiUrl}/ConversionMapping/GetMaterialConversionProcessForAddUpdate?materialId=${materialId}&conversionProcessId=${conversionProcessId}`
      )
      .toPromise();
  }

  addUpdateConversionMapping(payload: any) {
    return this.http.post<any>(
      `${this.apiUrl}/ConversionMapping/AddUpdateMaterialConversionProcess`,
      payload
    );
  }

  deleteConversionMapping(id: any) {
    return this.http.delete<any>(
      `${this.apiUrl}/ConversionMapping/DeleteMaterialConversionProcess?id=${id}`
    );
  }

  getRecycledList(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/RecycledContent/GetRecycledContentList`, payload);
  }

  async getaddUpdateRecycledContentFormDetails(materialId: any, regionId: any) {
    return this.http
      .get<any>(
        `${this.apiUrl}/RecycledContent/GetRecycledContentForAddUpdate?materialId=${materialId}&regionId=${regionId}`
      )
      .toPromise();
  }

  // other data EquivalancyUnits
  getCountryIndetifiersList(payload: any) {
    return this.http.post<any>(
      `${this.apiUrl}/CountryIndetifiers/GetCountryIndetifiersList`,
      payload
    );
  }

  getAllCountryIndetifiersList() {
    return this.http.get<any>(`${this.apiUrl}/CountryIndetifiers/GetAllCountryIndetifiersList`);
  }
  getCountryIndetifiersModalList(regionId: any, countryIdentifierId: any) {
    return this.http
      .get<any>(
        `${this.apiUrl}/CountryIndetifiers/GetCountryIndetifiersForAddUpdate?regionId=${regionId}&countryIdentifierId=${countryIdentifierId}`
      )
      .toPromise();
  }

  deleteCountryIndetifiersData(countryIdentifierId: any, regionId: any) {
    return this.http.delete<any>(
      `${this.apiUrl}/CountryIndetifiers/DeleteCountryIndetifiers?countryIdentifierId=${countryIdentifierId}&regionId=${regionId}`
    );
  }

  addUpdateCountryIndetifiers(payload: any) {
    return this.http.post<any>(
      `${this.apiUrl}/CountryIndetifiers/AddUpdateCountryIndetifiers`,
      payload
    );
  }

  addUpdateRecycledContent(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/RecycledContent/AddUpdateRecycledContent`, payload);
  }

  getProductPackageRatioList(payload: any) {
    return this.http.post<any>(
      `${this.apiUrl}/ProductPackageRatio/GetProductPackageRatioList`,
      payload
    );
  }

  getAllProductPackageRatioList() {
    return this.http.get<any>(`${this.apiUrl}/ProductPackageRatio/GetAllProductPackageRatioList`);
  }

  getaddUpdateProductPackageFormDetails(sectorIdentifierId: any, regionId: any) {
    return this.http
      .get<any>(
        `${this.apiUrl}/ProductPackageRatio/GetProductPackageRatioForAddUpdate?sectorIdentifierId=${sectorIdentifierId}&regionId=${regionId}`
      )
      .toPromise();
  }

  addUpdateProductPackageRatio(payload: any) {
    return this.http.post<any>(
      `${this.apiUrl}/ProductPackageRatio/AddUpdateProductPackageRatio`,
      payload
    );
  }

  deleteProductPackaging(sectorsIdentifierId: any, regionId: any) {
    return this.http.delete<any>(
      `${this.apiUrl}/ProductPackageRatio/DeleteProductPackageRatio?sectorsIdentifierId=${sectorsIdentifierId}&regionId=${regionId}`
    );
  }

  deleteRecycledContent(materialId: any, regionId: any) {
    return this.http.delete<any>(
      `${this.apiUrl}/RecycledContent/DeleteRecycledContent?materialId=${materialId}&regionId=${regionId}`
    );
  }

  // MiscSimulation
  getMiscSimulationList() {
    return this.http.get<any>(`${this.apiUrl}/MiscSimulation/GetAllMiscSimulationList`);
  }

  deleteMiscSimulationData(energyprocessId: any, regionId: any) {
    return this.http.delete<any>(
      `${this.apiUrl}/MiscSimulation/DeleteMiscSimulation?energyprocessId=${energyprocessId}&&regionId=${regionId}`
    );
  }

  GetMiscSimulationModalData(energyprocessId: any, regionId: any) {
    return this.http
      .get<any>(
        `${this.apiUrl}/MiscSimulation/GetMiscSimulationDataForAddUpdate?energyprocessId=${energyprocessId}&regionId=${regionId}`
      )
      .toPromise();
  }

  GetRegionsForMiscSimulation(energyprocessId: any) {
    return this.http.get<any>(
      `${this.apiUrl}/MiscSimulation/GetRegions?energyprocessId=${energyprocessId}`
    );
  }

  addUpdateMiscSimulation(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/MiscSimulation/AddUpdateMiscSimulation`, payload);
  }
  getAuditHistorylist(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/LogEntries/GetAuditHistorylist`, payload);
  }

  getAllAuditHistorylist() {
    return this.http.get<any>(`${this.apiUrl}/LogEntries/GetAllAuditHistorylist`);
  }
  getAuditHistoryDetailModal(id: any, primaryId: any, name: any) {
    return this.http
      .get<any>(
        `${this.apiUrl}/LogEntries/GetAuditHistoryDetail?id=${id}&pkId=${primaryId}&name=${name}`
      )
      .toPromise();
  }

  getAdminCountryList(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/Country/GetCountryList`, payload);
  }

  getAllCountryList() {
    return this.http.get<any>(`${this.apiUrl}/Country/GetAllCountry`);
  }

  getAdminCountryFormData(id: any) {
    return this.http.get<any>(`${this.apiUrl}/Country/GetCountryForAddUpdate?id=${id}`).toPromise();
  }

  addUpdateCountry(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/Country/AddUpdateCountry`, payload);
  }

  deleteCountry(id: any) {
    return this.http.delete<any>(`${this.apiUrl}/Country/DeleteCountry?id=${id}`);
  }

  getAdminStateList(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/State/GetStateList`, payload);
  }

  getAllStateList() {
    return this.http.get<any>(`${this.apiUrl}/State/GetAllStateList`);
  }

  addUpdateState(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/State/AddUpdateState`, payload);
  }

  getAdminStateFormData(id: any) {
    return this.http.get<any>(`${this.apiUrl}/State/GetStateForAddUpdate?id=${id}`).toPromise();
  }

  deleteState(id: any) {
    return this.http.delete<any>(`${this.apiUrl}/State/DeleteState?id=${id}`);
  }

  getAdminCityList(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/City/GetCityList`, payload);
  }

  getAllAdminCityList() {
    return this.http.get<any>(`${this.apiUrl}/City/GetAllCityList`);
  }

  getAdminCityFormData(id: any) {
    return this.http.get<any>(`${this.apiUrl}/City/GetCityForAddUpdate?id=${id}`).toPromise();
  }

  addUpdateCity(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/City/AddUpdateCity`, payload);
  }

  deleteCity(id: any) {
    return this.http.delete<any>(`${this.apiUrl}/City/DeleteCity?id=${id}`);
  }

  getAdminImportList(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/ImportExcel/GetImportLogList`, payload);
  }

  getAllImportLogList() {
    return this.http.get<any>(`${this.apiUrl}/ImportExcel/GetAllImportLogList`);
  }
  getAdminExportLogs() {
    return this.http.get<any>(`${this.apiUrl}/AdminExportLogs/ExportLogReport`);
  }

  deleteImportFile(id: any) {
    return this.http.delete<any>(`${this.apiUrl}/ImportExcel/DeleteImportFile?id=${id}`);
  }
  getProjectList(orgId: any) {
    return this.http.post<any>(
      `${this.apiUrl}/Project/GetProjectsByOrganizatrion?organizationId=${orgId}`,
      {}
    );
  }

  getAllOrganizationList() {
    return this.http.get<any>(`${this.apiUrl}/Organization/GetOrganizationLookUpList`).toPromise();
  }

  getEntireOrganizationList(payload: any) {
    return this.http
      .post<any>(`${this.apiUrl}/Organization/GetOrganizationList`, payload)
      .toPromise();
  }

  getAdminNewsList(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/News/GetNewsList`, payload);
  }

  getAllNewsList() {
    return this.http.get<any>(`${this.apiUrl}/News/GetAllNewsList`);
  }

  getAdminSelectedExportLogs(organizationId: any, isAdmin: any, projectjList: any) {
    return this.http.get<any>(
      `${this.apiUrl}/Project/ExportProjectData?organizationId=${organizationId}&projectjList=${projectjList}`
    );
  }

  GetMaterialInfo(materialId: any, regionId: any) {
    return this.http.get<any>(
      `${this.apiUrl}/Material/GetMaterialInfo?materialId=${materialId}&regionId=${regionId}`
    );
  }
  getAdminNewsDetailsList(id: any) {
    return this.http.get<any>(`${this.apiUrl}/News/GetNewsDetail?id=${id}`).toPromise();
  }

  getAddNewsDetailsFormData(id: any) {
    return this.http.get<any>(`${this.apiUrl}/News/GetNewsForAddUpdate?id=${id}`).toPromise();
  }

  addUpdateNews(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/News/AddUpdateNews`, payload);
  }

  updateUserNewsNotification(newsId: any) {
    return this.http.get<any>(`${this.apiUrl}/News/updateUserNewsNotification?newsId=${newsId}`);
  }

  getAdminRolesList(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/Roles/GetRoleList`, payload);
  }

  getAllDocumentList(payload: any) {
    return this.http
      .post<any>(
        `${this.apiUrl}/MyOrganizationPreferences/GetAllOrganizationTermsDocument`,
        payload
      )
      .toPromise();
  }
  getAllAnalyticsList(payload: any) {
    return this.http
      .post<any>(`${this.apiUrl}/CustomerDemoRequest/GetCustomerDemoRequestsList`, payload)
      .toPromise();
  }

  getAdminAllRoleList(id: any, userId?: any) {
    return this.http.get<any>(
      `${this.apiUrl}/Roles/GetAllRoleList?organizationId=${id}&userId=${userId ? userId : null}`
    );
  }

  deleteNews(id: any) {
    return this.http.delete<any>(`${this.apiUrl}/News/DeleteNews?id=${id}`);
  }

  addRole(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/Roles/AddUpdateRole`, payload);
  }

  getAdminRolesDetails(id: any, orgId: any) {
    return this.http.get<any>(
      `${this.apiUrl}/Roles/GetRoleDetail?roleId=${id}&organizationId=${orgId}`
    );
  }

  deleteRole(id: any, orgId: any) {
    return this.http.delete<any>(
      `${this.apiUrl}/Roles/DeleteRole?roleId=${id}&organizationId=${orgId}`
    );
  }

  updateAdminRoleAccess(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/Roles/UpdateRoleModule`, payload);
  }

  //load project Data
  loadProjectData(organizationId: any) {
    return this.http.post<any>(
      `${this.apiUrl}/Project/LoadProjects?organizationId=${organizationId}`,
      {}
    );
  }

  exportFileFun(formData: FormData) {
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    const options = { headers: headers, timeout: 600000 };
    return this.http.post<any>(`${this.apiUrl}/ImportExcel/AddImportFile`, formData, options);
  }

  GetIngredientRegions(ingredientId: any) {
    return this.http.get<any>(`${this.apiUrl}/Ingredient/GetRegions?ingredientId=${ingredientId}`);
  }

  removeOrganizationImage(Organization: any) {
    return this.http.get<any>(
      `${this.apiUrl}/Organization/RemoveOrganizationImage?OrganizationId=${Organization}`
    );
  }

  copyOrganization(fromOrganizationId: any, toOrganizationId: any, scheduleDate: any) {
    return this.http.get<any>(
      `${this.apiUrl}/Organization/CopyOrganization?fromOrganizationId=${fromOrganizationId}&toOrganizationId=${toOrganizationId}&scheduleDate=${scheduleDate}`
    );
  }
  getAllSessionAnalytics(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/User/GetUserSessionAnalytics`, payload).toPromise();
  }
  getAllActivitySessionAnalytics(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/User/GetUserActivityAnalytics`, payload).toPromise();
  }

  getAllSignupRequestListPaginated(payload: {
    search: string;
    pageSize: number;
    pageNumber: number;
  }) {
    return this.http.post<any>(`${this.apiUrl}/User/GetAllTrialOrganizations`, payload).toPromise();
  }

  updatePiqetLcaApiRoleAccessCache(payload: any) {
    return this.http.post<any>(`${this.piqetLcaApiUrl}/Auth/RefreshCache`, payload);
  }

  getLcaApiUserAnalytics(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/User/GetLcaApiUserAnalytics`, payload).toPromise();
  }

  getUserDetailedAnalytics(request: any) {
    return this.http
      .post<any>(`${this.apiUrl}/User/GetLcaApiUserDetailedAnalytics`, request)
      .toPromise();
  }

  reEnqueueImportFile(id: any) {
    return this.http.get<any>(`${this.apiUrl}/ImportExcel/ReEnqueueImportFile?id=${id}`);
  }

  importValidatedFile(payload: { id: any; version: string | null; comment: string | null }) {
    return this.http.post<any>(`${this.apiUrl}/ImportExcel/ImportFile`, payload);
  }

  getImportValidationErrorLog(payload: {
    id: any;
    page: number;
    pageSize: number;
    sheet: string;
    code: string;
    severity: number | null;
  }) {
    return this.http.post<any>(
      `${this.apiUrl}/ImportValidationError/GetErrorLogForImportProject`,
      payload
    );
  }

  getImportReportForProject(id: any) {
    return this.http.get<any>(
      `${this.apiUrl}/ImportValidationError/GetImportReportForProject?id=${id}`
    );
  }

  // Master Data Versioning
  getMasterDataVersions(includeArchived = false) {
    return this.http.get<any>(
      `${this.apiUrl}/master-data/versions?includeArchived=${includeArchived}`
    );
  }

  getMasterDataSchemaVersions() {
    return this.http.get<any>(`${this.apiUrl}/master-data/schema-versions`);
  }

  createMasterDataSnapshot(payload: {
    VersionName: string;
    SchemaVersionId: number;
    AutoPromote: boolean;
  }) {
    return this.http.post<any>(`${this.apiUrl}/master-data/snapshot`, payload);
  }

  setMasterDataVersionActive(id: number) {
    return this.http.post<any>(`${this.apiUrl}/master-data/versions/${id}/set-active`, {});
  }

  archiveMasterDataVersion(id: number) {
    return this.http.post<any>(`${this.apiUrl}/master-data/versions/${id}/archive`, {});
  }
}
